import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import * as courseApi from '../../../api/course-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Select from 'react-select';
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css'
import ReactDOM from 'react-dom';
import Chip from 'material-ui/Chip';

//var termArr = [];
class ProfileSkill extends React.Component {
    constructor(props) {
        super(props);


        var my = this.props.my;

        this.state = {loading: false, profileId: this.props.profileId, my: my, skillArr: [], skillOps: [], item: {}};
        this.styles = {
            chip: {
                margin: 4,
                fontSize: '8pt'
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap',
            },
        };
        //profileId = this.props.profileId;
        //this.getCourses = this.getCourses.bind(this);
    }


    componentDidMount() {

        this.setState({loading: true}, () => {
            this.getUserSkills();
        });


    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({
                loading: loading,
                profileId: nextProps.profileId,
                my: my,
                skillArr: [],
                skillOps: []
            }, () => {
                this.getUserSkills();
            });
        }
        else {
            this.setState({profileId: nextProps.profileId, my: my});
        }


        //profileId = nextProps.profileId;
        //this.getCourses();
    }

    getUserSkills() {
        axios.get(commonApi.getAPIURL() + '?api=getUserSkills&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    var skillArr = [];
                    for (var item of response.data.data) {


                        if (this.state.my) {
                            skillArr.push(
                                <Chip
                                    key={"profile-skill-item-" + item.id_skill}
                                    onRequestDelete={this.removeSkill.bind(this, item)}
                                    style={this.styles.chip}
                                    labelStyle={{fontSize: "8pt"}}
                                >
                                    {item.name_skill}
                                </Chip>
                            );
                        }
                        else {
                            skillArr.push(
                                <Chip
                                    key={"profile-skill-item-" + item.id_skill}

                                    style={this.styles.chip}
                                    labelStyle={{fontSize: "8pt"}}
                                >
                                    {item.name_skill}
                                </Chip>
                            );
                        }


                    }
                    this.setState({skills: response.data.data, skillArr: skillArr});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                this.setState({loading: false});
                //console.log(response.data);

                return response;
            });
    }


    save(e) {
        var item = this.state.item;

        if (item.skill == undefined) {
            commonApi.showAlert("Please select skill");
            return;
        }


        var data = new FormData();

        data.append('skill', item.skill);
        data.append('user_id', this.state.profileId);
        axios.post(commonApi.getAPIURL() + '?api=updateSkill', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});
                    this.getUserSkills();


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });


    }

    onSelectSkill(item) {
        var it = this.state.item;

        it.skill = item.value;
        this.setState({item: it});
    }

    getOptions(input) {
        if (input.length == 0 || input.length < 2) {
            //this.setState({location:""});
            this.setState({skillOps: this.state.skillOps});

        }
        else {
            var data = new FormData();

            data.append('search', input);
            axios.post(commonApi.getAPIURL() + '?api=searchSkill', data, {
                progress: (progressEvent) => {

                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for (var item of response.data.data) {
                            var name = item.name_skill;
                            array.push({value: item.id_skill, label: name});
                            i++;
                        }
                        this.setState({skillOps: array});
                        //callback(null, {options: array});
                    } else {
                        //callback(null, {options: []});
                    }
                    //console.log(response.data);

                    return response;
                }).catch(error => {
                //callback(null, {options: []});
            });

        }
        //console.log(callback);

        //return testop;
    }

    cancel(e) {
        this.setState({show: false, item: {}});
    }


    removeSkill(it) {
        var data = new FormData();
        data.append('id', it.id_skill);
        data.append('user_id', this.state.profileId);
        axios.post(commonApi.getAPIURL() + '?api=removeSkill', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});

                    this.getUserSkills();


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });
    }

    render() {
        // if(this.state.terms == undefined){
        // return (
        // <div className="page_course_box profile_content_wrapper">
        // <div >
        // <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width="20px" height="20px" /> Loading</div>
        // </div>
// 					
        // </div>
        // );
        // }


        return (
            <div
                className={(this.state.my || this.state.skillArr.length > 0) && this.state.loading == false ? "page_course_box profile_content_wrapper" : "hide-el"}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_skill.png"/>
                    <div className="title">
                        Skills
                    </div>
                </div>
                {this.state.my ? (
                    <div className="des" style={{fontSize: '9pt'}}><img src="/static/img/appimg/icon_i.png"/> Click to
                        add skills suggested for you</div>) : ""}
                <div style={this.styles.wrapper}>
                    {this.state.skillArr}
                </div>
                {this.state.my ? (
                    <div className="inline_block">
                        <div style={{float: "left", width: "71%"}}><Select
                            name="form-field-name"
                            value={this.state.item.skill}
                            options={this.state.skillOps}
                            onChange={this.onSelectSkill.bind(this)}
                            placeholder=""
                            onInputChange={this.getOptions.bind(this)}
                            noResultsText="No Skill found"
                            clearable={false}
                            searchable={true}
                        /></div>
                        <a onClick={this.save.bind(this)} style={{padding: '9px 15px'}}
                           className="btn_v btn_confirm fright">Add</a>
                    </div>) : ""}
            </div>

        )
    }
}

export default ProfileSkill;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_skill.js
 **/